import { motion } from "framer-motion";
import { CalendarCheck2, ListChecks, FolderCheck, MessagesSquare, LifeBuoy, TrendingUp, Quote } from "lucide-react";
import { Reveal, SectionHead, EASE } from "./Reveal";

const CARDS = [
  {
    icon: CalendarCheck2,
    title: "Scadenze più chiare",
    desc: "Consulta le prossime attività e le date importanti, così sai sempre che cosa deve essere fatto e quando.",
    span: "md:col-span-6",
  },
  {
    icon: ListChecks,
    title: "Adempimenti sotto controllo",
    desc: "Segui in modo semplice ciò che è in lavorazione, ciò che è stato completato e ciò che richiede la tua attenzione.",
    span: "md:col-span-6",
  },
  {
    icon: FolderCheck,
    title: "Documenti organizzati",
    desc: "Trova, consulta e condividi più facilmente i documenti relativi alla tua Partita IVA, all'interno di un unico ambiente.",
    span: "md:col-span-4",
  },
  {
    icon: MessagesSquare,
    title: "Comunicazione diretta",
    desc: "Contatta il professionista direttamente attraverso Human Factor, senza inseguire email, telefonate o interlocutori diversi.",
    span: "md:col-span-4",
  },
  {
    icon: LifeBuoy,
    title: "Supporto quando serve",
    desc: "Ricevi spiegazioni, indicazioni e assistenza sulla tua situazione, con risposte comprensibili e contestualizzate.",
    span: "md:col-span-4",
  },
  {
    icon: TrendingUp,
    title: "Gestione più consapevole",
    desc: "Hai una visione più ordinata della tua posizione e delle attività da svolgere, riducendo il rischio di errori, ritardi e dimenticanze.",
    span: "md:col-span-12",
  },
];

export default function Servizio() {
  return (
    <section
      id="servizio"
      data-testid="section-il-servizio"
      className="relative border-y border-white/5 bg-slate-950/40 py-24 lg:py-32"
    >
      <div className="pointer-events-none absolute right-[-6%] top-[10%] h-[400px] w-[400px] rounded-full bg-[#19D6E8]/10 blur-[130px]" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead
          eyebrow="Il servizio"
          title={
            <>
              Tutto sotto controllo: <span className="text-gradient">un unico spazio</span> per la tua Partita IVA
            </>
          }
          sub="Human Factor raccoglie in una sola applicazione tutto ciò che ti serve per seguire la tua posizione fiscale e amministrativa, senza dover cercare informazioni tra email, messaggi, documenti e promemoria diversi."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-12">
          {CARDS.map((c, i) => (
            <motion.div
              key={c.title}
              data-testid={`servizio-card-${i}`}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: EASE }}
              whileHover={{ y: -6 }}
              className={`glow-card group flex h-full flex-col gap-4 rounded-3xl p-7 ${c.span}`}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl border border-cyan-400/25 bg-cyan-400/10 text-cyan-300 transition-all duration-300 group-hover:bg-gradient-to-br group-hover:from-[#1B6EF3] group-hover:to-[#19D6E8] group-hover:text-white">
                <c.icon className="h-5 w-5" />
              </span>
              <h3 className="font-display text-xl font-bold tracking-tight sm:text-2xl">{c.title}</h3>
              <p className="max-w-2xl text-sm leading-relaxed text-slate-400 sm:text-base">{c.desc}</p>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div
            data-testid="servizio-conclusione"
            className="mx-auto mt-12 flex max-w-3xl flex-col items-center gap-4 rounded-3xl border border-white/10 bg-gradient-to-br from-[#1B6EF3]/10 to-[#19D6E8]/5 p-8 text-center sm:p-10"
          >
            <Quote className="h-6 w-6 text-cyan-300" />
            <p className="font-display text-lg font-semibold leading-relaxed text-slate-100 sm:text-xl">
              «Human Factor <span className="text-gradient">semplifica la gestione quotidiana della tua P.IVA</span>{" "}
              senza aggiungere un altro software complicato da imparare ad utilizzare.»
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
